
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/tranche-dates",
      function () {
        return require("private-next-pages/portal/tranche-dates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal/tranche-dates"])
      });
    }
  